declare global {
  interface Window {
    Rokt?: RoktType;
  }
}

// Custom error class for client-side blocking
export class RoktClientBlockedError extends Error {
  constructor(message = "Rokt script blocked by client environment") {
    super(message);
    this.name = "RoktClientBlockedError";
  }
}

export interface RoktType {
  createLauncher: (config: RoktLauncherConfig) => Promise<RoktLauncherInstance>;
}

export interface RoktLauncherConfig {
  accountId: string;
  sandbox?: boolean;
}

export interface RoktLauncherInstance {
  selectPlacements: (options: RoktPlacementOptions) => Promise<RoktSelection>;
  terminate: () => void;
}

export interface RoktPlacementOptions {
  attributes: Record<string, string | undefined | boolean | null>;
  identifier: string;
}

export interface RoktSelection {
  close: () => void;
}
